import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams } from '@ag-grid-community/core/dist/esm/es6/headerRendering/cells/column/headerComp';

import { Component, signal } from '@angular/core';
import { environment } from '@env/environment';
import { ClickOutsideDirective } from 'shared/directives/click-outside.directive';
import { SharedModule } from 'shared/shared.module';

@Component({
    selector: 'app-listing-table-select-header',
    templateUrl: './listing-table-select-header.component.html',
    styleUrls: ['./listing-table-select-header.component.scss'],
    imports: [SharedModule, ClickOutsideDirective],
})
export class ListingTableSelectHeaderComponent implements IHeaderAngularComp {
    protected readonly environment = environment;

    public params!: IHeaderParams;
    public isPartiallyChecked = false;
    public totalNumberOfRows = 0;
    public menuVisible = signal<boolean>(false);
    public selectionListingsMap?: Map<string, Object>;

    public agInit(params: IHeaderParams): void {
        this.params = params;
        this.selectionListingsMap = this.params.context.selectionListingsMap;

        this.params.api.addEventListener('filterModified', () => {
            this.deselectAll();
        });

        this.params.api.addEventListener('rowSelected', () => {
            this.totalNumberOfRows = this.params.context.getTotalItemsNumber();
        });

        this.params.api.addEventListener('paginationChanged', () => {
            this.deselectAll();
            this.params.api.forEachNode((node: any) => {
                if (this.selectionListingsMap?.has(node.data?.id)) {
                    node.setSelected(true);
                }
            });
        });
    }

    public onCheckboxChanged(event: any) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.menuVisible.set(true);
    }

    public selectAllOnPage() {
        this.menuVisible.set(false);
        this.params.context.selectAllOnPage();
    }

    public selectAllAcrossPages() {
        this.menuVisible.set(false);
        this.params.context.selectAll();
    }

    public refresh(params: IHeaderParams): boolean {
        return false;
    }

    public deselectAll() {
        this.menuVisible.set(false);
        this.isPartiallyChecked = false;
        this.params.api.deselectAll();
    }

    public clearSelectionStore() {
        this.params.context.selectionListingsMap.clear();
    }
}
